import { motion } from "framer-motion";
import Category from "../../components/icons/Category";

export default function MenuLandingGrid({ categories, isLoading, onCategorySelect }) {

    // Skeleton interno della griglia
    if (isLoading) {
        return (
            <div className="px-5 py-8 max-w-md mx-auto animate-pulse">
                <div className="flex flex-col items-center mb-10 space-y-2">
                    <div className="h-3 bg-[#121824] rounded w-20 mx-auto" />
                    <div className="h-5 bg-[#1A2234] rounded w-1/2 mx-auto" />
                </div>
                <div className="grid grid-cols-3 gap-y-8 gap-x-4 justify-items-center">
                    {Array.from({ length: 6 }).map((_, index) => (
                        <div key={index} className="flex flex-col items-center space-y-3 bg-[#121824]/30 w-full p-4 rounded-2xl border border-accent/5">
                            <div className="w-16 h-16 rounded-full bg-[#1A2234]" />
                            <div className="w-12 h-3 bg-[#1A2234] rounded" />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    // Griglia reale
    return (
        <div className="px-5 py-8 max-w-md mx-auto">
            <div className="flex flex-col items-center mb-10 text-center">
                <span className="text-[10px] uppercase tracking-[0.3em] text-primary font-bold mb-1 opacity-80">Il Nostro Menù</span>
                <h2 className="text-lg font-black tracking-wider uppercase text-secondary">
                    Scegli una categoria
                </h2>
                <div className="w-8 h-[2px] bg-primary/40 mt-3 rounded-full" />
            </div>

            <div className="grid grid-cols-3 gap-y-8 gap-x-4">
                {categories?.map((item, index) => (
                    <motion.div
                        key={index}
                        whileTap={{ scale: 0.94 }}
                        className="flex flex-col items-center cursor-pointer bg-[#121824]/40 border border-accent/10 p-3 rounded-2xl shadow-sm hover:border-accent/30 transition-all duration-200"
                        onClick={() => onCategorySelect(item.id)}
                    >
                        <Category name={item.name} icon={item.icon} isSelected={false} size="lg" />
                    </motion.div>
                ))}
            </div>
        </div>
    );
}